import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import seminar from '../assets/seminar.png';
import { Link } from 'react-router-dom';

class Seminar041025 extends Component {
  state = { walletInfo: {} };
  render() {
    return (
      <div className='AllClasses' style={{ textAlign: "center" }}>
        {/* Big seminar logo at the top */}
        <img
          className="seminar-logo"
          src={seminar}
          alt="Seminar Logo"
          style={{ width: "300px", marginBottom: "20px" }}
        />

        <h3>Participant's Organizations Day 2</h3>
        <br /><br />

        <div><Link to='/seminarsingapore2'>1. Singapore Members</Link></div>
        <br />
        <div><Link to='/seminarmalaysia2'>2. Malaysia Members</Link></div>
        <br />
        <div><Link to='/seminarhongkong2'>3. Hong Kong Members</Link></div>
        <br />
        <div><Link to='/seminarchina2'>4. China Members</Link></div>
        <br />
        <div><Link to='/seminarmarine2'>5. Marines Martial Arts Members</Link></div>
        <br />
        <div><Link to='/seminartuksom2'>6. Aikido Tuksom Members</Link></div>
        <br />
        <div><Link to='/seminarchula2'>7. Chulalongkorn University Aikido Club Members</Link></div>
        <br />
        <div><Link to='/seminarwongwianyai2'>8. Aikido Wongwian Yai Members</Link></div>
        <br />
        <div><Link to='/seminarchiangmai2'>9. Northern Aikido Members</Link></div>
        <br />
        <div><Link to='/seminarkorat2'>10. Aikido Korat Dojo Members</Link></div>
        <br />
        <div><Link to='/seminarmasakatsu2'>11. Masakatsu Renbukan Dojo Members</Link></div>
        <br />
        <div><Link to='/seminarfudokan2'>12. Fudokan Dojo</Link></div>
        <br />
        <div><Link to='/seminarbmz2'>13. BMZ Dojo Members</Link></div>
        <br />
        <div><Link to='/seminardindang2'>14. Thai-Japan Youth Center Members</Link></div>
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br /><br />

        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="logo" style={{ width: "120px" }} />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default Seminar041025;
